const PAYROLL_ACTIONS = {
  //dashboard payroll
  GET_ALL_PAYROLL_REQUEST: "GET_ALL_PAYROLL_REQUEST",
  GET_ALL_PAYROLL_SUCCESS: "GET_ALL_PAYROLL_SUCCESS",
  GET_ALL_PAYROLL_FAIL: "GET_ALL_PAYROLL_FAIL",
  GET_PAYROLL_DETAIL_REQUEST: "GET_PAYROLL_DETAIL_REQUEST",
  GET_PAYROLL_DETAIL_SUCCESS: "GET_PAYROLL_DETAIL_SUCCESS",
  GET_PAYROLL_DETAIL_FAIL: "GET_PAYROLL_DETAIL_FAIL",
};
export default PAYROLL_ACTIONS;
